import { useEffect } from 'react';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { CampdeskLogo } from '@/components/svg/CampdeskLogo.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';

export const AppErrorPage = ({ error, reset }: ErrorComponentProps) => {
  // Always log the caught error so it's visible in the console — without
  // this the user just sees "Przerwa techniczna" with no clue what blew up.
  useEffect(() => {
    console.error('[AppErrorPage]', error);
  }, [error]);

  const isDev = import.meta.env.DEV;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-8">
      <CampdeskLogo width="130" height="30" />
      <div className="mt-12 flex max-w-md flex-col items-center gap-6 text-center">
        <h1 className="text-basic-900 text-2xl font-semibold">
          Przerwa techniczna
        </h1>
        <p className="text-neutral-600">
          Coś poszło nie tak. Przepraszamy za utrudnienia - spróbuj odświeżyć
          stronę za chwilę.
        </p>
        <ActionButton
          tone="accent"
          size="sm"
          onClick={() => (reset ? reset() : window.location.reload())}
        >
          Odśwież stronę
        </ActionButton>
      </div>

      {isDev && error && (
        <details className="mt-12 w-full max-w-3xl rounded-md border border-error-100 bg-error-50/40 p-4 text-left text-xs">
          <summary className="cursor-pointer font-semibold text-error-300">
            Debug (dev only): {error.message}
          </summary>
          <pre className="mt-2 overflow-x-auto whitespace-pre-wrap text-neutral-700">
            {error.stack ?? String(error)}
          </pre>
        </details>
      )}
    </div>
  );
};

export default AppErrorPage;
